import { cast, SnapshotIn, types } from 'mobx-state-tree'

export interface ISelectorOption {
  id: number
  type: string
  label: string
  subLabel?: string
  photo_url?: string
  parentId?: number
  childCount?: number
  subItems?: ISelectorOption[]
  number_users?: number
}

export const SelectorOption = types
  .model('SelectorOption')
  .props({
    id: types.number,
    type: types.string,
    label: types.string,
    subLabel: types.optional(types.string, ''),
    photo_url: types.maybe(types.string),
    parentId: types.maybe(types.number),
    childCount: types.maybe(types.number),
    checked: types.optional(types.boolean, false),
    subItems: types.maybeNull(types.array(types.late((): any => SelectorOption))),
  })
  .actions((self) => {
    return {
      set<K extends keyof SnapshotIn<typeof self>, T extends SnapshotIn<typeof self>>(
        key: K,
        value: T[K],
      ) {
        // @ts-ignore
        self[key] = cast(value)
      },
      setChecked(status: boolean) {
        self.checked = status
      },
    }
  })
